module.exports = __webpack_public_path__ + "img/ep-logo2.dd06cd14.svg";